
export const cfg: {
    name: string,
    position: {
        center: [number, number],
        zoom: number
        , extent?: [number, number, number, number]
    },
    mapDivId: string,
    apiUrlBase: string
} = {
    name: "com.maploom.client.api.1",
    position: {
        center: [-2, 51.55],
        zoom: 13,
        extent: [-10, 50, 3, 60]
    },
    mapDivId: 'client-map-container',    // if change must change in css file also
    apiUrlBase: "https://www.maploom.com"
    // apiUrlBase: "https://www.maploom.com:9000"
}